import { motion } from 'framer-motion';
import styles from './Hero.module.css';
import Button from '../ui/Button';

export default function Hero() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 16 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: 'easeOut' }
    }
  };

  return (
    <section className={styles.hero} id="hero">
      <motion.div
        className={styles.container}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div variants={itemVariants} className={styles.heroRow}>
          <img src="/ojs_funko.png" alt="Omari Sanders" className={styles.headshot} />
          <h1 className={styles.headline}>Omari Sanders</h1>
        </motion.div>
        <motion.p variants={itemVariants} className={styles.subheadline}>
          Software architect and founder. 20 years building systems for federal agencies, private sector, and enterprise clients.
        </motion.p>
        <motion.div variants={itemVariants} className={styles.ctas}>
          <Button to="#ventures" variant="primary">View my work</Button>
          <Button to="#contact" variant="secondary">Get in touch</Button>
        </motion.div>
      </motion.div>
    </section>
  );
}
